export default "__VITE_ASSET__018c8634__"